export const normalizarValorBusqueda = (value = '') => (
  String(value ?? '').trim().replace(/\s+/g, ' ').toLocaleLowerCase('es-CL')
);

export const obtenerCamposBusquedaGiftcard = ({ numeroId, nombrePersona } = {}) => ({
  numeroIdBusqueda: normalizarValorBusqueda(numeroId),
  nombrePersonaBusqueda: normalizarValorBusqueda(nombrePersona),
});
